import React, { FC } from 'react';
import Form from 'components/Form';

import { VanishPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Vanish: FC<VanishPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Vanish;
